function formatToNumber(value) {
  if (value === undefined || value === null || isNaN(value)) {
    return 'Valor inválido';  // Retorna um valor padrão caso o valor seja inválido
  }
  return value.toFixed(2);
}
 
 
export default formatToNumber;